import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'ecp-alarm',
    templateUrl: './alarm.component.html',
    styleUrls: ['./alarm.component.css'],
    animations: [
        trigger('displayState', [
            state('none', style({
                display: 'none', opacity: '0',
            })),
            state('block', style({
                display: 'block', opacity: '1',
            })),
            transition('none => block', animate('100ms linear')),
            transition('block => none', animate('80ms linear'))
        ])
    ]
})
export class AlarmComponent implements OnInit {
    isShow: boolean = false;
    // ä¼ å¥åè¡¨
    @Input() ecpAlarmList: Array<string> = [];
    // ä¼ å¥åè¡¨æ»é¿åº¦
    @Input() ecpAlarmTotal: number = 0;
    // ä¼ å¥æ é¢
    @Input() ecpAlarmTitle: string;
    // åä¼ ID
    // @Output() disposed = new EventEmitter<string>();
    // ç¹å»âæ¥çå¨é¨âåä¼ 
    @Output() ecpViewAll = new EventEmitter();

    /*

      dispose(id) {
        this.disposed.emit(id);
        // alert(id);
      }
    */

    viewMore() {
        this.ecpViewAll.emit();
    }

    /* æµè¯
      alarmList = [
        {
          id: '1',
          title: 'æµéè®¡ã004557ã200æµéè¶è¿10mÂ³'

        },
        {
          id: '2',
          title: 'ã00DX34557ã200æµéè¶è¿10mÂ³'

        },
        {
          id: '3',
          title: 'æµéè®¡ã00DX34557ã200æµè¶è¿10mÂ³'

        },
        {
          id: '4',
          title: 'æµéè®¡ã00DX4557ãæµéè¶è¿10mÂ³'

        },
        {
          id: '5',
          title: 'æµé200æµéè®¡ã20æµéã200æµéè¶è¿10mÂ³'

        },
        {
          id: '6',
          title: '200æµéæµéè®¡ã00D557ã200æµéè¶è¿10mÂ³'

        },
        {
          id: '7',
          title: 'æµéè®¡200æµéã00D57ã200æµéè¶è¿10mÂ³'

        },
        {
          id: '8',
          title: 'æµéè®¡ã00DX34557ã200æµéè¶è¿10mÂ³'

        },
        {
          id: '9',
          title: '200æµéè®¡ã00DX34557ã200æµè¿10mÂ³'

        },
        {
          id: '10',
          title: 'æµéè®¡ã00DX34557ã200æµéè¶è¿10mÂ³'

        }
      ];
    */


    constructor() {
    }

    ngOnInit() {
        if (this.ecpAlarmTotal == 0) {
            this.ecpAlarmTotal = this.ecpAlarmList.length;
        }
        // console.log('alarmList', this.alarmList);
    }

}
